import type {AxiosInstance} from "axios";
import axios from "axios";
import {environment} from "../env";

export function buildAxiosInstance(baseURL: string, delay?: number | undefined): AxiosInstance {
    const http = axios.create({
        baseURL,
        headers: {
            "Content-type": "application/json"
        }
    });
    delay = delay === undefined ? environment.apiDelay : delay;
    if (delay > 0) {
        http.interceptors.request.use(c => {
            console.debug(`Mithra request delay of ${delay}ms on ${c.url}`)
            return new Promise(r => setTimeout(() => r(c), delay));
        });
    }
    return http;
}


/**
 * @see https://stackoverflow.com/questions/35855781/having-services-in-react-application
 */
export abstract class ApiService {
    constructor(public http: AxiosInstance) {
    }
}

export namespace mithra_http {
    export const mockApi = buildAxiosInstance('/');
    export const mockApiSlow = buildAxiosInstance('/', 1500);
}
